export default {
    VIDEO: {
        MAX_SIZE: 100,
        RED_LINE: 50,
        BLACK_LINE: 2,
        TYPES: {
            MP4: 'MP4',
            mp4: 'mp4',
            MOV: 'MOV',
            mov: 'mov',
            WMV: 'WMV',
            AVI: 'AVI',
            avi: 'avi',
            mkv: 'mkv'
        }
    },
    IMAGE: {
        TYPES: {
            jpg: 'jpg',
            JPG: 'JPG',
            jpeg: 'jpeg',
            JPEG: 'JPEG',
            jfif: 'jfif',
            pjpeg: 'pjpeg',
            pjp: 'pjp',
            png: 'png',
            PNG: 'PNG',
            webp: 'webp'
        }
    }
};

